<div
    class="flex gap-x-1 flex-row justify-center items-center"
    [id]="`plan_cassette_${cassetteKey()}`">
    @if (!openedCassettesKeys().includes(cassetteKey())) {
        <ng-container
            [ngTemplateOutlet]="cassettePlus"
            [ngTemplateOutletContext]="{ side: CableDirectionEnum.LEFT }" />
    }

    <div class="boxPlan__cassette grow">
        <div
            class="flex flex-row items-center gap-x-1 lg:gap-x-2 px-2 lg:px-4 text-base text-secondary min-h-[1.875rem] w-full">
            <mat-checkbox
                color="primary"
                [checked]="synopticPlanEditService.selectedCassettes().has(cassetteKey())"
                (change)="toggleCassetteSelection()" />
            <p class="grow">
                <span class="inline flex-nowrap"
                    >{{ 'synopticPlan.cassette' | transloco }} {{ cassetteNumber() }} :
                </span>
                <span>{{ cassetteKey() }} ({{ connectedFibersRatio() }})</span>
            </p>

            <fa-icon
                class="bg-white text-error-button cursor-pointer"
                [icon]="['fas', 'trash']"
                (click)="remove.emit()" />
            <fa-stack
                class="flex cursor-pointer"
                id="chevron"
                size="sm"
                (click)="toggleCassetteDetails()">
                <fa-icon
                    stackItemSize="2x"
                    [icon]="['fas', 'circle']" />
                <fa-icon
                    stackItemSize="1x"
                    [icon]="['fas', isOpened() ? 'chevron-up' : 'chevron-down']" />
            </fa-stack>
        </div>
        @if (isOpened()) {
            <div>
                <div class="boxPlan__cassette__content__row">
                    <p>{{ 'synopticPlan.incomingPosition' | transloco }}</p>
                    <p class="boxPlan__cassette__content__inactiveTitle">
                        {{ 'synopticPlan.connectorization' | transloco }}
                    </p>
                    <p>{{ 'synopticPlan.outgoingPosition' | transloco }}</p>
                </div>
                @for (fiber of cassette(); track $index) {
                    <div
                        class="boxPlan__cassette__content__row boxPlan__cassette__content__row__connect__edit cursor-pointer"
                        [style]="getConnectorStyle(fiber)"
                        (click)="updatePositionValue(fiber)">
                        <p>
                            <app-cassette-anchor-edit
                                [anchorId]="`boxPlan_fibre_${cassetteKey()}_${fiber.cable_entrant}_${fiber.fibre_entrante}`"
                                [cassetteKey]="cassetteKey()"
                                [fiberNumber]="fiber.numero_fibre_entrante"
                                [isContinue]="fiber.est_en_continuite"
                                [positionId]="fiber.ps_uuid"
                                [side]="CableDirectionEnum.LEFT" />
                        </p>
                        <p class="min-w-24">
                            <span
                                class="edit-connectorization text-sm inline-block w-full"
                                style="box-shadow: black 0 0 0 1px"
                                [style]="getConnectorizationBorder(fiber)">
                                {{ fiber.numero_position }}.
                                <em class="text-custom-blue text-semibold">{{ fiber.connectorisation }}</em>
                                - {{ fiber.type_ingenierie }}-{{ fiber.affectation }}
                            </span>
                        </p>
                        <p>
                            <app-cassette-anchor-edit
                                [anchorId]="`boxPlan_fibre_${cassetteKey()}_${fiber.cable_sortant}_${fiber.fibre_sortante}`"
                                [cassetteKey]="cassetteKey()"
                                [fiberNumber]="fiber.numero_fibre_sortante"
                                [isContinue]="fiber.est_en_continuite"
                                [positionId]="fiber.ps_uuid"
                                [side]="CableDirectionEnum.RIGHT" />
                        </p>
                    </div>
                }
            </div>
        }
    </div>

    @if (!openedCassettesKeys().includes(cassetteKey())) {
        <ng-container
            [ngTemplateOutlet]="cassettePlus"
            [ngTemplateOutletContext]="{ side: CableDirectionEnum.RIGHT }" />
    }
</div>

<ng-template
    #cassettePlus
    let-side="side">
    @let selectionEnabled = side === CableDirectionEnum.LEFT ? isEntranceSelectionEnabled() : isExitSelectionEnabled();
    @let isItemSelected = isCassetteSelected(side);

    <button
        class="plusButton"
        [class.plusButton_fibers_assigned]="!selectionEnabled"
        [class.plusButton_fibers_free]="selectionEnabled"
        [class.plusButton_selected]="isItemSelected"
        [class.plusButton_unselected]="!isItemSelected && selectionEnabled"
        [disabled]="!selectionEnabled"
        [id]="`plus_${cassetteKey()}_${side}`"
        (click)="selectCassette(side)">
        <fa-icon
            [class]="selectionEnabled ? 'text-custom-blue' : 'text-custom-dark-grey'"
            [icon]="['fas', 'plus']" />
    </button>
</ng-template>
